import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { ServiceType } from "@/types/referals";

interface UserInfoState {
  serviceType: ServiceType | null;
  yandexId: string;
  isAdviceBannerOpen: boolean;
  setYandexId: (elem: string) => void;
  setIsAdviceBannerOpen: (elem: boolean) => void;
}

export const useUserInfoStore = create<UserInfoState>()(
  persist(
    (set) => ({
      serviceType: null,
      yandexId: "",
      isAdviceBannerOpen: true,
      setYandexId: (elem) =>
        set(() => ({
          yandexId: elem,
        })),
      setIsAdviceBannerOpen: (elem) =>
        set(() => ({
          isAdviceBannerOpen: elem,
        })),
    }),

    {
      name: "user-info",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
